export const PaymentTerms = [
    {
        id: 1,
        name: "Pro Forma Payment"
    },
    {
        id: 7,
        name: "7 days"
    },
    {
        id: 14,
        name: "14 days"
    },
    {
        id: 21,
        name: "21 days"
    },
    {
        id: 30,
        name: "30 days"
    },
    {
        id: 45,
        name: "45 days"
    },
    {
        id: 60,
        name: "60 days"
    }
];
